
import { CHART_VARIANT, VARIANT_MAPPING } from '../config/chartConfig'

export type ChartVariant =
  | typeof CHART_VARIANT.LIFECYCLE_STATUS
  | typeof CHART_VARIANT.OPERATING_STATUS
  | typeof CHART_VARIANT.ASSET_AGE
  | typeof CHART_VARIANT.DEFAULT

export function normalizeText(value?: string): string {
  return value?.trim().toLowerCase().replace(/\s+/g, '') || ''
}

export function getVariantFromLabel(chartLabel: string): ChartVariant {
  const normalizedLabel = normalizeText(chartLabel)

  if (VARIANT_MAPPING[normalizedLabel]) {
    return VARIANT_MAPPING[normalizedLabel] as ChartVariant
  }

  if (normalizedLabel.includes('lifecycle')) {
    return CHART_VARIANT.LIFECYCLE_STATUS
  }

  if (
    normalizedLabel.includes('operating') ||
    normalizedLabel.includes('currentoperatingstatus')
  ) {
    return CHART_VARIANT.OPERATING_STATUS
  }

  if (normalizedLabel.includes('assetage') || normalizedLabel.includes('age')) {
    return CHART_VARIANT.ASSET_AGE
  }

  return CHART_VARIANT.DEFAULT
}

export function resolveChartVariant(
  variant?: string,
  chartLabel?: string,
  dataKey?: string
): ChartVariant {

  if (variant) {
    const normalizedVariant = normalizeText(variant)
    if (Object.values(CHART_VARIANT).includes(normalizedVariant as ChartVariant)) {
      return normalizedVariant as ChartVariant
    }
  }


  if (dataKey) {
    return getVariantFromLabel(dataKey)
  }

  if (chartLabel) {
    return getVariantFromLabel(chartLabel)
  }

  return CHART_VARIANT.DEFAULT
}
